<template>
  <v-container fluid class="ma-0 pa-0">
    <v-divider class="footer-divider" />
    <v-footer height="auto" class="savitarna-footer app--footer" color="white">
      <div v-html="content" />
    </v-footer>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import headerData from './headerData'
import request from '@/util/savitarnaMenu'

export default {
  name: 'SavFooter',
  mixins: [headerData],
  data() {
    return {
      content: null,
    }
  },

  computed: {
    ...mapGetters(['savitarnaXid']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      if (!this.isLocal) {
        request({
          url: `footer.do;jsessionid=${this.savitarnaXid}`,
          method: 'get',
        }).then(res => {
          this.content = this.parseFooter(res.data)
        })
      } else {
        if (this.isLocal) {
          this.content = this.parseFooter(this.footerData)
        }
      }
    },
    parseFooter(data) {
      data = data.replace(/^.*?(?=<div id="footer-in">)/s, '')
      data = data.replace(/(?=<\/body>).*?$/s, '')
      return data
    },
  },
}
</script>
<style lang="scss">
.savitarna-footer {
  width: 999px;
  margin: 0 auto;
  padding: 0;
}
</style>
